'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = ComponentMap;

var _combineReducers = require('nanotools/lib/combineReducers');

var _combineReducers2 = _interopRequireDefault(_combineReducers);

var _identityReducer = require('nanotools/lib/identityReducer');

var _identityReducer2 = _interopRequireDefault(_identityReducer);

var _invariant = require('nanotools/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _DynamicReducerComponent = require('redux-components/lib/DynamicReducerComponent');

var _DynamicReducerComponent2 = _interopRequireDefault(_DynamicReducerComponent);

var _MapMetadata = require('./util/MapMetadata');

var _MapMetadata2 = _interopRequireDefault(_MapMetadata);

var _diff = require('./util/diff');

var _diff2 = _interopRequireDefault(_diff);

var _metadataSymbol = require('./util/metadataSymbol');

var _metadataSymbol2 = _interopRequireDefault(_metadataSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ComponentMap(typeMap) {
  // Support objects as typemaps
  if (typeof typeMap !== 'function') {
    var typeMapObject = typeMap;
    typeMap = function typeMap(key) {
      return typeMapObject[key];
    };
  }

  return function (_DynamicReducerCompon) {
    (0, _inherits3.default)(ComponentMap, _DynamicReducerCompon);

    function ComponentMap() {
      (0, _classCallCheck3.default)(this, ComponentMap);

      var _this = (0, _possibleConstructorReturn3.default)(this, (ComponentMap.__proto__ || (0, _getPrototypeOf2.default)(ComponentMap)).call(this));

      _this.metadata = new _MapMetadata2.default();
      return _this;
    }

    (0, _createClass3.default)(ComponentMap, [{
      key: '__notifyChildren',
      value: function __notifyChildren(state) {
        this.metadata.getSubject().next(state);
        var componentMap = this.componentMap;
        for (var k in componentMap) {
          componentMap[k].getSubject().next(state);
        }
      }
    }, {
      key: 'updateReducer',
      value: function updateReducer(didDropKeys) {
        this.replaceReducer((0, _combineReducers2.default)(this.reducerMap, didDropKeys));
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if ((0, _get3.default)(ComponentMap.prototype.__proto__ || (0, _getPrototypeOf2.default)(ComponentMap.prototype), 'componentWillMount', this)) {
          (0, _get3.default)(ComponentMap.prototype.__proto__ || (0, _getPrototypeOf2.default)(ComponentMap.prototype), 'componentWillMount', this).call(this);
        }
        this.reducerMap = (0, _create2.default)(null);
        this.reducerMap[_metadataSymbol2.default] = this.metadata.reducer;
        this.componentMap = (0, _create2.default)(null);
        // Mount the metadata node.
        this.metadata.__willMount(this.store, this.path.concat([_metadataSymbol2.default]), this);
        this.updateReducer();
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.preMount) {
          this.metadata.bulk(this.preMount);
          delete this.preMount;
        }
        // Diff whenever metadata changes.
        this.subscription = this.metadata.getMetadata.subscribe({
          next: function next(metadata) {
            return _diff2.default.call(_this2, typeMap, metadata);
          }
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        // Unsub from observer
        if (this.subscription) {
          this.subscription.unsubscribe();
          delete this.subscription;
        }
        // Unmount subcomponents
        for (var k in this.componentMap) {
          var v = this.componentMap[k];
          v.__willUnmount();
        }
        this.metadata.__willUnmount();
        this.replaceReducer(_identityReducer2.default);
        delete this.componentMap;
        delete this.reducerMap;
      }

      // API: get(key)
      // Retrieve a component by key from the map.

    }, {
      key: 'get',
      value: function get(key) {
        if (process.env.NODE_ENV !== 'production') {
          (0, _invariant2.default)(this.componentMap, 'Illegal call to ComponentMap.get() on an unmounted ComponentMap.');
        }
        return this.componentMap[key];
      }

      // API: keys()
      // Retrieve an array consisting of all keys of the map.

    }, {
      key: 'keys',
      value: function keys() {
        return (0, _keys2.default)(this.componentMap);
      }

      // API: forEach(callback, thisArg)
      // Iterate the map, like `Map.forEach`

    }, {
      key: 'forEach',
      value: function forEach(callback, thisArg) {
        if (thisArg) {
          for (var k in this.componentMap) {
            callback.call(thisArg, this.componentMap[k], k, this);
          }
        } else {
          for (k in this.componentMap) {
            callback(this.componentMap[k], k, this);
          }
        }
      }

      // API: has(key)

    }, {
      key: 'has',
      value: function has(key) {
        if (this.componentMap[key]) return true;else return false;
      }

      // API: add(key, descriptor)

    }, {
      key: 'add',
      value: function add(key, descriptor) {
        if (this.isMounted()) {
          if (key in this.componentMap) throw new Error('duplicate key "' + key + '" in ComponentMap');
          this.metadata.add(key, descriptor);
        } else {
          if (!this.preMount) this.preMount = {};
          this.preMount[key] = descriptor;
        }
      }

      // API: remove(key)

    }, {
      key: 'remove',
      value: function remove(key) {
        if (this.isMounted()) {
          this.metadata.remove(key);
        } else {
          if (this.preMount) delete this.preMount[key];
        }
      }
    }]);
    return ComponentMap;
  }(_DynamicReducerComponent2.default); // class ComponentMap
}